
export const subsidies = {
  'subsidies.title': 'Subsidy Matches',
  'subsidies.subtitle': 'Available subsidies that match your farm profile',
  'subsidies.matchConfidence': 'Match Confidence',
  'subsidies.deadline': 'Deadline',
  'subsidies.regionEligibility': 'Regional Eligibility',
  'subsidies.grantCode': 'Grant Code',
  'subsidies.maxGrant': 'Maximum Grant',
  'subsidies.draftDate': 'Draft Date',
  'subsidies.status': 'Status',
  'subsidies.reminder': 'Reminder',
  'subsidies.searchEngine': 'European Subsidy Search Engine',
  'subsidies.fundingType': 'Funding Type',
  'subsidies.countryEligibility': 'Country Eligibility',
  'subsidies.agriculturalSector': 'Agricultural Sector',
  'subsidies.farmingMethod': 'Farming Method',
  'subsidies.grantValue': 'Grant Value',
  'subsidies.certifications': 'Certifications',
  'subsidies.matchConfidenceSlider': 'Match Confidence',
  'subsidies.resultsFound': 'subsidies found for your criteria',
  'subsidies.noMatchCriteria': 'No matching subsidies for your filters.',
  'subsidies.public': 'Public',
  'subsidies.private': 'Private',
  'subsidies.mixed': 'Mixed',
  'subsidies.attachToFarm': 'Attach to Farm',
  'subsidies.selectFarm': 'Select a Farm to Attach',
  'subsidies.noSubsidies': 'No Subsidies Available',
  'subsidies.viewDetails': 'View Details',
  'subsidies.eligibilityCriteria': 'Eligibility Criteria',
  'subsidies.apply': 'Apply',
  'subsidies.importFromPortal': 'Import from Portal',
  'subsidies.region': 'Region',
  'subsidies.matchScore': 'Match Score',
  'subsidies.searchResults': 'Search Results',
  'subsidies.noSubsidiesFound': 'No subsidies found',
  'subsidies.noSubsidiesFoundDesc': 'No subsidies found that match your criteria',
  'subsidies.filters': 'Filters',
  'subsidies.sortByLabel': 'Sort by',
  'subsidies.fundingType.public': 'Public',
  'subsidies.fundingType.private': 'Private',
  'subsidies.fundingType.mixed': 'Mixed',
  'subsidies.fundingTypePublic': 'Public',
  'subsidies.fundingTypePrivate': 'Private',
  'subsidies.fundingTypeMixed': 'Mixed',
  'subsidies.searchSubsidies': 'Search Subsidies',
  'subsidies.findAvailableSubsidies': 'Find available subsidies for your farms',
  'subsidies.currentlyAvailable': 'Currently {count} subsidies available',
  
  // New filter translations for search
  'search.filters.title': 'Refine Results',
  'search.filters.geographicEligibility': 'Geographic Eligibility',
  'search.filters.region': 'Region',
  'search.filters.eligibleCountry': 'Eligible Country',
  
  'search.filters.agriculturalSector': 'Agricultural Sector',
  'search.filters.farmingType': 'Farming Type',
  'search.filters.farmingType.arableCrops': 'Arable Crops',
  'search.filters.farmingType.vineyards': 'Vineyards',
  'search.filters.farmingType.livestock': 'Livestock',
  'search.filters.farmingType.aquaculture': 'Aquaculture',
  'search.filters.farmingType.mixedFarming': 'Mixed Farming',
  'search.filters.farmingType.greenhouse': 'Greenhouse / Vertical Farming',
  
  'search.filters.fundingType': 'Funding Type',
  'search.filters.fundingSource': 'Funding Source',
  'search.filters.fundingSource.public': 'Public (EU, National)',
  'search.filters.fundingSource.private': 'Private (Bank, VC)',
  'search.filters.fundingSource.hybrid': 'Hybrid (Public-Private)',
  'search.filters.fundingInstrument': 'Funding Instrument',
  'search.filters.fundingInstrument.grant': 'Grant',
  'search.filters.fundingInstrument.subsidy': 'Subsidy',
  'search.filters.fundingInstrument.taxCredit': 'Tax Credit',
  'search.filters.fundingInstrument.loan': 'Loan',
  'search.filters.fundingInstrument.technicalAssistance': 'Technical Assistance',
  
  'search.filters.applicationRequirements': 'Application Requirements',
  'search.filters.documentsRequired': 'Documents Required',
  'search.filters.documentsRequired.businessPlan': 'Business Plan',
  'search.filters.documentsRequired.sustainabilityReport': 'Sustainability Report',
  'search.filters.documentsRequired.carbonAssessment': 'Carbon Assessment',
  'search.filters.documentsRequired.euFarmId': 'EU Farm ID',
  'search.filters.documentsRequired.digitalCertification': 'Digital Certification',
  'search.filters.documentsRequired.previousGrantRecord': 'Previous Grant Record',
  'search.filters.applicationFormat': 'Application Format',
  'search.filters.applicationFormat.online': 'Online',
  'search.filters.applicationFormat.pdf': 'PDF',
  'search.filters.applicationFormat.portal': 'Via Portal',
  'search.filters.applicationFormat.consultant': 'With Consultant Only',
  
  'search.filters.strategicAlignment': 'Strategic Alignment',
  'search.filters.sustainabilityGoals': 'Sustainability Goals',
  'search.filters.sustainabilityGoals.organicTransition': 'Organic Transition',
  'search.filters.sustainabilityGoals.waterEfficiency': 'Water Efficiency',
  'search.filters.sustainabilityGoals.emissionReduction': 'Emission Reduction',
  'search.filters.sustainabilityGoals.soilHealth': 'Soil Health',
  'search.filters.sustainabilityGoals.biodiversity': 'Biodiversity',
  'search.filters.sustainabilityGoals.climateAdaptation': 'Climate Adaptation',
  
  'search.filters.deadlineStatus': 'Deadline Status',
  'search.filters.deadline': 'Deadline',
  'search.filters.deadline.open': 'Open',
  'search.filters.deadline.closingSoon': 'Closing Soon (within 30 days)',
  'search.filters.deadline.closed': 'Closed (archive search)',
  
  'search.filters.noMatches': 'No subsidies match your filters. Try broadening your criteria.',
  'search.filters.saveFilterSet': 'Save Filter Set',
  'search.filters.savedFilters': 'Saved Filters',
  'search.filters.enterFilterSetName': 'Enter a name for this filter set',
  'search.filters.save': 'Save',
  'search.filters.cancel': 'Cancel',
  
  'subsidies.viewAttached': 'View Attached',
  'search.actions.attached': 'Attached',
  'search.actions.attach': 'Attach to Farm',

  // Search Page UI
  'search.placeholder': 'Search funding opportunities...',
  'search.button': 'Search',
  'search.popularSearches': 'Popular searches:',
  'search.smartFilters': 'Smart Filters',
  'search.findIdealMatch': 'Find your ideal funding match',
  'search.popularCombinations': 'Popular Combinations:',
  'search.searchAndFilterOptions': 'Search & Filter Options',
  'search.yourSavedSearches': 'Your Saved Searches',
  'search.saveFilters': 'Save Filters',
  'search.noSavedFilters': 'No saved filter sets yet',
  'search.locationEligibility': 'Location & Eligibility',
  'search.frenchRegions': 'French Regions',
  'search.countryTerritory': 'Country/Territory',
  'search.enterCountry': 'Enter your country (France, EU, etc.)',
  'search.businessSector': 'Business & Sector',
  'search.activitySector': 'Activity Sector',
  'search.fundingDetails': 'Funding Details',
  'search.typeOfFunding': 'Type of Funding',
  'search.applicationStatus': 'Application Status',
  'search.currentlyOpen': 'Currently Open',
  'search.closingSoon': 'Closing Soon',
  'search.recentlyAdded': 'Recently Added',
  'search.highSuccessRate': 'High Success Rate',
  'search.fundingOrganizations': 'Funding Organizations',
  'search.majorFunders': 'Major Funders',
  'search.otherOrganizations': 'Other Organizations',
  'search.fundingAmount': 'Funding Amount',
  'search.expectedAmountRange': 'Expected Amount Range',
  'search.amountFilteringUnavailable': 'Amount filtering temporarily unavailable - all subsidies shown regardless of amount selection.',
  'search.applicationRequirements': 'Application Requirements',
  'search.farmGoalsSustainability': 'Farm Goals & Sustainability',
  'search.applicationTimeline': 'Application Timeline',

  // Update timestamps
  'search.recentlyUpdated': 'Recently updated',
  'search.updatedJustNow': 'Updated just now',
  'search.updatedHoursAgo': 'Updated {hours} hours ago',
  'search.updatedYesterday': 'Updated yesterday',
  'search.updatedDaysAgo': 'Updated {days} days ago',
  'search.updatedOn': 'Updated {date}',

  // EmptySubsidyState
  'search.empty.noSubsidiesAvailable': 'No Subsidies Available',
  'search.empty.noSubsidiesDescription': 'No subsidies are currently available in the database. Check back later for new opportunities.',
  'search.empty.noMatchingSubsidies': 'No Matching Subsidies',
  'search.empty.noMatchingDescription': 'No subsidies match your search for "{query}" and current filters.',
  'search.empty.noMatchingFiltersDescription': 'No subsidies match your current filter criteria.',
  'search.empty.clearAllFilters': 'Clear All Filters',
  'search.empty.errorLoadingSubsidies': 'Error Loading Subsidies',
  'search.empty.errorDescription': 'Unable to load subsidy data. Please try again.',
  'search.empty.tryAgain': 'Try Again',
  'search.empty.noResults': 'No Results',
  'search.empty.noResultsDescription': 'No results to display.',

  // SmartFilterSuggestions
  'search.smartSuggestions.title': 'Smart Filter Suggestions',
  'search.smartSuggestions.popularFilters': 'Popular filters other users find helpful:',
  'search.smartSuggestions.unproductiveWarning': 'Unproductive filters detected',
  'search.smartSuggestions.unproductiveDescription': 'These filters typically return no results: {filters}',
  'search.smartSuggestions.uses': '{count} uses',

  // SearchResultsPanel
  'search.results.currentlyAvailable': 'Currently {count} subsidies available',
  'search.results.recentlyClosed': 'Recently Closed ({count})',
  'search.results.relaxedSearch': 'We relaxed your search due to special characters. Showing results for "{query}".',

  // SavedFilterSets
  'search.savedFilters.applyFilters': 'Apply Filters',
  'search.savedFilters.filtersCount': '{count} filters',

  // SubsidyFilters
  'search.filters.active': 'active',
  'search.filters.clearAll': 'Clear All',

  // OrganizationFilter
  'search.filters.moreOrganizations': '+{count} more organizations',
  'search.filters.loadingOrganizations': 'Loading organizations...',

  // AmountRangeFilter - Fallback ranges
  'search.filters.amountRange.lessThan10k': 'Less than €10,000',
  'search.filters.amountRange.10kTo50k': '€10,000 - €50,000',
  'search.filters.amountRange.50kTo100k': '€50,000 - €100,000',
  'search.filters.amountRange.100kTo500k': '€100,000 - €500,000',
  'search.filters.amountRange.moreThan500k': 'More than €500,000',

  // GeographicEligibilityFilter
  'search.filters.moreRegions': '+{count} more regions',

  // RecommendedSection
  'search.recommended.title': 'Recommended for You',
  'search.recommended.loading': 'Loading...',
  'search.recommended.noRecommendations': 'No personalized recommendations available',
  'search.recommended.noRecommendationsWithQuery': 'No personalized recommendations match "{query}"',

  // Subsidy Detail Page UI Elements
  'detail.back': 'Back',
  'detail.backToDiscovery': 'Discovery',
  'detail.backToSearch': 'Search',
  'detail.subsidyNotFound': 'Subsidy Not Found',
  'detail.subsidyNotFoundDesc': 'The requested subsidy could not be found.',
  'detail.deadline': 'Deadline',

  // Tab navigation (consolidated 4 tabs)
  'detail.tabs.overview': 'Overview',
  'detail.tabs.conditions': 'Conditions',
  'detail.tabs.candidature': 'Application',
  'detail.tabs.contact': 'Contact',
  // Legacy tab keys (kept for backwards compatibility)
  'detail.tabs.eligibility': 'Eligibility',
  'detail.tabs.financial': 'Financial',
  'detail.tabs.requirements': 'Requirements',
  'detail.tabs.process': 'Process',
  'detail.tabs.legal': 'Legal',
  'detail.tabs.administrative': 'Administrative',
  'detail.tabs.documents': 'Documents',

  // Overview section
  'detail.overview.subsidyDetails': 'Subsidy Details',
  'detail.overview.description': 'Description',
  'detail.overview.geographicEligibility': 'Geographic Eligibility',
  'detail.overview.nationalCoverage': 'National Coverage',
  'detail.overview.regions': 'Regions',
  'detail.overview.departments': 'Departments',
  'detail.overview.programFocus': 'Program Focus',
  'detail.overview.targetSectors': 'Target Sectors',
  'detail.overview.eligibleApplicants': 'Eligible Applicants',
  'detail.overview.eligibleUses': 'Eligible Uses',
  'detail.overview.keyRequirements': 'Key Requirements',
  'detail.overview.availability': 'Availability',
  'detail.overview.helpfulTips': 'Helpful Tips',
  'detail.overview.detailedInfo': 'Informations détaillées',
  'detail.overview.moreEligibleUses': 'And {count} more eligible uses...',
  'detail.overview.moreRequirements': 'And {count} more requirements...',
  'detail.overview.moreRegions': '+{count} more',
  'detail.overview.eligibleExpenses': 'Eligible expenses',
  'detail.overview.programContext': 'Program context',
  'detail.overview.applicationTiming': 'Application period',

  // Eligibility section
  'detail.eligibility.title': 'Eligibility Criteria',
  'detail.eligibility.detailedCriteria': 'Detailed Eligibility Criteria',
  'detail.eligibility.targetAudiences': 'Target Audiences',
  'detail.eligibility.eligibleLegalEntities': 'Eligible Legal Entities',
  'detail.eligibility.keyRequirements': 'Key Requirements',
  'detail.eligibility.restrictions': 'Restrictions',
  'detail.eligibility.notAvailable': 'Detailed eligibility criteria not available',
  'detail.eligibility.contactAgency': 'Contact the agency for specific requirements',

  // Financial section
  'detail.financial.title': 'Financial Details',
  'detail.financial.detailedFinancial': 'Informations financières détaillées',
  'detail.financial.fundingAmount': 'Funding Amount',
  'detail.financial.grantDetails': 'Grant Details',
  'detail.financial.loanOption': 'Loan Option',
  'detail.financial.recoverableAdvance': 'Recoverable Advance',
  'detail.financial.coFinancingRate': 'Co-financing Rate',
  'detail.financial.fundingDetails': 'Funding Details',
  'detail.financial.upTo': 'Up to',
  'detail.financial.from': 'From',
  'detail.financial.nonRepayableGrant': 'Non-repayable grant',
  'detail.financial.repayableLoan': 'Repayable loan',
  'detail.financial.conditionalRepayment': 'Conditional repayment',
  'detail.financial.maxPercentageCovered': 'Maximum percentage of project costs covered',

  // Contact section
  'detail.contact.title': 'Contact Information',
  'detail.contact.contactsAdmin': 'Contacts and administrative process',
  'detail.contact.contactOrganization': 'Contact Organization',
  'detail.contact.contactInfo': 'Contact Information',
  'detail.contact.service': 'Service',
  'detail.contact.contact': 'Contact',
  'detail.contact.notAvailable': 'Contact information not available',
  'detail.contact.agency': 'Agency',
  'detail.contact.organization': 'Organization',
  'detail.contact.contactPerson': 'Contact person',
  'detail.contact.phone': 'Phone',
  'detail.contact.email': 'Email',
  'detail.contact.website': 'Website',
  'detail.contact.address': 'Address',
  'detail.contact.noContactInfo': 'No contact information available',

  // Sidebar
  'detail.sidebar.assignToProfiles': 'Assign to a Profile',
  'detail.sidebar.assignedProfiles': 'Assigned Profiles ({count})',
  'detail.sidebar.assignToProfile': 'Add to a profile',
  'detail.sidebar.selectProfilesToAssign': 'Select profiles to assign',
  'detail.sidebar.loadingProfiles': 'Loading profiles...',
  'detail.sidebar.noProfilesFound': 'No profiles found. Create a profile first.',
  'detail.sidebar.alreadyAssigned': ' - Already assigned',
  'detail.sidebar.assign': 'Assign',
  'detail.sidebar.assignCount': 'Assign ({count})',
  'detail.sidebar.cancel': 'Cancel',
  'detail.sidebar.historicalIntelligence': 'Historical Intelligence',
  'detail.sidebar.keyInformation': 'Key Information',
  'detail.sidebar.fundingAmount': 'Funding Amount',
  'detail.sidebar.region': 'Region',
  'detail.sidebar.fundingType': 'Funding Type',
  'detail.sidebar.sectors': 'Sectors',
  'detail.sidebar.targetDemographics': 'Target Demographics',
  'detail.sidebar.recurrence': 'Recurrence',
  'detail.sidebar.targetAudience': 'Target Audience',
  'detail.sidebar.deadline': 'Deadline',

  // Hero card actions
  'detail.actions.save': 'Save',
  'detail.actions.saved': 'Saved',
  'detail.actions.apply': 'Apply',
  'detail.actions.share': 'Share',
  'detail.actions.linkCopied': 'Link copied to clipboard',
  'detail.actions.savingComingSoon': 'Save feature coming soon',

  // Messages and notifications
  'detail.messages.selectProfile': 'Please select at least one profile to assign',
  'detail.messages.assignSuccess': 'Subsidy assigned to {count} profile',
  'detail.messages.assignSuccessPlural': 'Subsidy assigned to {count} profiles',
  'detail.messages.assignFailed': 'Failed to assign subsidy to profiles',
  'detail.messages.removeSuccess': 'Profile assignment removed',
  'detail.messages.removeFailed': 'Failed to remove assignment',

  // Application section
  'detail.application.accessPagePrompt': 'Click below to access the official application page or learn more about this subsidy.',
  'detail.application.goToPage': 'Go to Application Page',
  'detail.application.notAvailable': 'Application information not available',

  // Geographic display
  'detail.geographic.nationalFrance': 'National (France)',
  'detail.geographic.moreRegions': '+{count} more',

  // Recurrence values
  'detail.recurrence.permanent': 'Permanent',
  'detail.recurrence.annual': 'Annual',
  'detail.recurrence.biannual': 'Biannual',
  'detail.recurrence.monthly': 'Monthly',
  'detail.recurrence.quarterly': 'Quarterly',
  'detail.recurrence.oneTime': 'One-time',
  'detail.recurrence.ongoing': 'Ongoing',
  'detail.recurrence.punctual': 'One-time',
  'detail.recurrence.permanente': 'Permanent',
  'detail.recurrence.unknown': 'Not specified',

  // Fallback values for missing data
  'detail.fallback.general': 'General',
  'detail.fallback.financialAid': 'Financial aid',
  'detail.fallback.allRegions': 'All regions',
  'detail.fallback.more': ' more',

  // Funding messages - already in FR but missing in EN
  'subsidies.funding.loanContactTerms': 'Loan - Contact for terms',
  'subsidies.funding.technicalAssistance': 'Technical assistance provided',
  'subsidies.funding.grantAmountPerProject': 'Grant - Amount determined per project',
  'subsidies.funding.financialAidVaries': 'Financial aid - Amount varies',
  'subsidies.funding.recoverableAdvance': 'Recoverable advance - Terms vary',
  'subsidies.funding.grantCaseByCase': 'Grant - Evaluated case by case',
  'subsidies.funding.contactForDetails': 'Contact for funding details',
  'subsidies.funding.loanAvailable': 'Loan available - €{amount}',
  'subsidies.funding.contactWithAidType': '{aidType} - Contact for details',

  // Documents section
  'detail.documents.requiredDocuments': 'Required Documents',
  'detail.documents.applicationForm': 'Application Form',
  'detail.documents.onlineApplicationForm': 'Online application form or portal',
  'detail.documents.required': 'Required',
  'detail.documents.type.form': 'Form',
  'detail.documents.type.legal': 'Legal',
  'detail.documents.type.reference': 'Reference',
  'detail.documents.type.application': 'Application',
  'detail.documents.type.document': 'Document',
  'detail.documents.open': 'Open',
  'detail.documents.additionalResources': 'Additional Resources',
  'detail.documents.officialSubsidyPage': 'Official Scheme Page',
  'detail.documents.originalSource': 'Original subsidy information source',
  'detail.documents.view': 'View',
  'detail.documents.summary': 'Document Summary',
  'detail.documents.summaryText': '{required} required documents, {additional} additional resources',
  'detail.documents.tip': 'Download and review all required documents before starting your application',
  'detail.documents.legalReferences': 'Legal References',
  'detail.documents.legalFramework': 'Official legal framework and regulations',
  'detail.documents.noRequiredDocuments': 'No required documents specified',
  'detail.documents.contactForRequirements': 'Contact the organization to learn about required documents',

  // Intelligence Insights section
  'detail.intelligence.createProfile': 'Create a profile to see personalized intelligence insights and success predictions.',
  'detail.intelligence.successPrediction': 'Success Prediction',
  'detail.intelligence.aiAnalysis': 'AI-powered analysis of your application potential',
  'detail.intelligence.successProbability': 'Success Probability',
  'detail.intelligence.eligibilityScore': 'Eligibility Score',
  'detail.intelligence.timeToApply': 'Time to Apply',
  'detail.intelligence.days': 'days',
  'detail.intelligence.requiredPreparation': 'Required Preparation',
  'detail.intelligence.riskFactors': 'Risk Factors',
  'detail.intelligence.marketIntelligence': 'Market Intelligence',
  'detail.intelligence.competitiveLandscape': 'Competitive landscape and market insights',
  'detail.intelligence.applicationVolume': 'Application Volume',
  'detail.intelligence.averageApplications': 'Average applications',
  'detail.intelligence.competitionTrend': 'Competition Trend',
  'detail.intelligence.increasing': 'Increasing',
  'detail.intelligence.stable': 'Stable',
  'detail.intelligence.averageAward': 'Average Award',
  'detail.intelligence.historicalSuccessRate': 'Historical Success Rate',
  'detail.intelligence.marketInsights': 'Market Insights',
  'detail.intelligence.smartActions': 'Smart Actions',
  'detail.intelligence.saveToFavorites': 'Save to Favorites',
  'detail.intelligence.setReminder': 'Set Reminder',
  'detail.intelligence.compareSimilar': 'Compare Similar',
  'detail.intelligence.startApplication': 'Start Application',

  // Section titles
  'detail.requirements.title': 'Application Requirements',
  'detail.process.title': 'Application Process',
  'detail.legal.title': 'Legal Framework',
  'detail.administrative.title': 'Administrative Details',

  // Application Requirements section
  'detail.requirements.notAvailable': 'Application process details not available',
  'detail.requirements.contactForInstructions': 'Contact the agency for application instructions',
  'detail.requirements.applyOnline': 'Apply Online',
  'detail.requirements.accessPortal': 'Access the official application portal to submit your request.',
  'detail.requirements.goToPortal': 'Go to Application Portal',
  'detail.requirements.timelineTitle': 'Timeline & Important Dates',
  'detail.requirements.applicationDeadline': 'Application Deadline',
  'detail.requirements.finalDate': 'Final date to submit your application',
  'detail.requirements.predepositDate': 'Pre-deposit Date',
  'detail.requirements.earlySubmission': 'Early submission or intent declaration',
  'detail.requirements.periodOpens': 'Application Period Opens',
  'detail.requirements.whenAccepted': 'When applications begin to be accepted',
  'detail.requirements.periodCloses': 'Application Period Closes',
  'detail.requirements.lastDay': 'Last day to submit applications',
  'detail.requirements.projectStartDate': 'Project Start Date',
  'detail.requirements.whenBegin': 'When funded projects should begin',
  'detail.requirements.fundingPeriod': 'Funding Period',
  'detail.requirements.durationAvailability': 'Duration of funding availability',
  'detail.requirements.generalDeadline': 'General Deadline',
  'detail.requirements.importantDate': 'Important date to remember',

  // Administrative Details section
  'detail.administrative.primaryAgency': 'Primary Administrative Agency',
  'detail.administrative.implementingOrg': 'Implementing Organization',
  'detail.administrative.fundingEntity': 'Funding Entity',
  'detail.administrative.technicalInstructor': 'Technical Instructor',
  'detail.administrative.complianceRequirements': 'Compliance Requirements',
  'detail.administrative.reportingRequirements': 'Reporting Requirements',
  'detail.administrative.evaluationCriteria': 'Evaluation Criteria',
  'detail.administrative.applicationOpens': 'Application Opens',
  'detail.administrative.predepositDeadline': 'Pre-deposit Deadline',
  'detail.administrative.applicationDeadline': 'Application Deadline',
  'detail.administrative.projectDuration': 'Project Duration',
  'detail.administrative.notAvailable': 'Administrative details not available',
  'detail.administrative.contactForGuidance': 'Contact the agency for administrative guidance',
  'detail.administrative.structure': 'Administrative Structure',
  'detail.administrative.contactDirectory': 'Contact Directory',
  'detail.administrative.primaryContact': 'Primary Contact',
  'detail.administrative.visitWebsite': 'Visit Website',
  'detail.administrative.additionalContacts': 'Additional Contacts',
  'detail.administrative.technicalSupport': 'Technical Support',
  'detail.administrative.expertise': 'Expertise: ',
  'detail.administrative.timeline': 'Administrative Timeline',
  'detail.administrative.compliance': 'Compliance & Requirements',
  'detail.administrative.mandatory': 'Mandatory',
  'detail.administrative.recommended': 'Recommended',

  // Legal Framework section
  'detail.legal.primaryAgency': 'Primary Agency',
  'detail.legal.administeringOrg': 'Administering Organization',
  'detail.legal.instructorOrg': 'Instructor Organization',
  'detail.legal.notAvailable': 'Legal framework information not available',
  'detail.legal.contactForDetails': 'Contact the agency for regulatory details',
  'detail.legal.aidClassification': 'Aid Classification',
  'detail.legal.regulations': 'Regulations: ',
  'detail.legal.legalBasis': 'Legal Basis',
  'detail.legal.administeringOrganizations': 'Administering Organizations',
  'detail.legal.regulatoryRequirements': 'Regulatory Requirements',
  'detail.legal.termsAndConditions': 'Terms and Conditions',
  'detail.legal.officialDocumentation': 'Official Legal Documentation',
  'detail.legal.viewFramework': 'View the complete legal framework and regulations governing this subsidy.',
  'detail.legal.accessReferences': 'Access Legal References',

  // Process Workflow section
  'detail.process.notAvailable': 'Detailed application process not available',
  'detail.process.contactForGuidance': 'Contact the agency for step-by-step guidance',
  'detail.process.applicationWorkflow': 'Application Steps',
  'detail.process.mobilizationWorkflow': 'Mobilization Steps',
  'detail.process.mobilizationDescription': 'Steps to activate and utilize your funding once approved:',
  'detail.process.documentChecklist': 'Document Checklist',
  'detail.process.documentChecklistDescription': 'Ensure you have all required documents before starting your application:',
  'detail.process.requirements': 'Requirements',
  'detail.process.responsible': 'Responsible:',
  'detail.process.documentTip': 'Tip: Check off documents as you prepare them to track your progress',

  // Search Filter Labels
  'search.filters.sector': 'Sector',
  'search.filters.amount': 'Amount',
  'search.filters.organization': 'Organization',
  'search.filters.frenchRegions': 'French Regions',
  'search.filters.activitySectors': 'Activity Sectors',
  'search.filters.fundingTypes': 'Funding Types',
  'search.filters.fundingAmount': 'Funding Amount',
  'search.filters.deadlinePeriod': 'Deadline',
  'search.filters.fundingOrganizations': 'Funding Organizations',
  'search.filters.noRegionsAvailable': 'No regions available',
  'search.filters.noSectorsAvailable': 'No sectors available',
  'search.filters.noTypesAvailable': 'No funding types available',
  'search.filters.noOrganizationsAvailable': 'No organizations available',
  'search.filters.openNow': 'Open now',
  'search.filters.closingSoon30Days': 'Closing soon (< 30d)',
  'search.filters.closing30to90Days': 'Closing in 30-90d',
  'search.filters.permanent': 'Permanent',

  // Report Missing Subsidy
  'report.missing.button': 'Report missing subsidy',
  'report.missing.buttonShort': 'Report missing',
  'report.missing.buttonMobile': 'Report',
  'report.missing.title': 'Report a Missing Subsidy',
  'report.missing.description': 'Know of a subsidy that\'s not in our database? Let us know and we\'ll add it!',
  'report.missing.name': 'Subsidy name',
  'report.missing.name.required': 'The subsidy name is required',
  'report.missing.name.placeholder': 'e.g. MaPrimeRénov\' 2025',
  'report.missing.url': 'Subsidy URL',
  'report.missing.url.required': 'The subsidy URL is required',
  'report.missing.url.invalid': 'Please enter a valid URL (starting with http:// or https://)',
  'report.missing.url.placeholder': 'https://...',
  'report.missing.url.help': 'Where did you find this subsidy? (official website, government page, etc.)',
  'report.missing.message': 'Additional information (Optional)',
  'report.missing.message.placeholder': 'Any additional context about this subsidy (eligibility, amounts, deadlines, etc.)',
  'report.missing.email': 'Your email (Optional)',
  'report.missing.email.placeholder': 'your.email@example.com',
  'report.missing.email.help': 'If you want to be notified when we add this subsidy',
  'report.missing.alert': 'Our team will review your submission and add the subsidy to our database if it is valid and relevant.',
  'report.missing.cancel': 'Cancel',
  'report.missing.submit': 'Submit Report',
  'report.missing.submitting': 'Sending...',
  'report.missing.success': 'Report sent successfully! We\'ll review and add this subsidy soon.',
  'report.missing.toast.success': 'Report sent!',
  'report.missing.toast.success.description': 'Thank you for helping us improve our database. We\'ll review this subsidy soon.',
  'report.missing.toast.error': 'Send failed',
  'report.missing.toast.error.description': 'Please try again later.',

  // Flag mismatch reporting
  'flag.button': 'Report issue',
  'flag.button.tooltip': 'This subsidy doesn\'t match your profile?',
  'flag.title': 'Report a matching issue',
  'flag.description': 'Help us improve our algorithm by telling us why this subsidy doesn\'t match your profile.',
  'flag.subtitle': 'Subsidy in question',
  'flag.reason.label': 'Why doesn\'t this subsidy match?',
  'flag.reason.placeholder': 'Select a reason...',
  'flag.reason.required': 'Please select a reason',
  'flag.additionalReasons.label': 'Other issues (optional)',
  'flag.explanation.label': 'Detailed explanation (optional)',
  'flag.explanation.placeholder': 'Describe the issue in detail to help us improve our algorithm...',
  'flag.severity.label': 'Issue severity',
  'flag.severity.low': 'Minor',
  'flag.severity.low.description': 'Slightly off-topic',
  'flag.severity.medium': 'Moderate',
  'flag.severity.medium.description': 'Doesn\'t really match',
  'flag.severity.high': 'Major',
  'flag.severity.high.description': 'Completely off-topic',
  'flag.severity.critical': 'Critical',
  'flag.severity.critical.description': 'Major error',
  'flag.cancel': 'Cancel',
  'flag.submit': 'Submit report',
  'flag.submitting': 'Sending...',
  'flag.success': 'Report sent successfully! We\'ll analyze this issue to improve our algorithm.',
  'flag.toast.success': 'Thank you for your report!',
  'flag.toast.success.description': 'Your feedback helps us improve result relevance.',
  'flag.toast.error': 'Send failed',
  'flag.toast.error.description': 'Please try again later.',
  'flag.info': 'Your report will be analyzed by our AI to automatically improve subsidy matching.',

  // Flag reasons
  'flag.reason.geography_match': 'Wrong region',
  'flag.reason.sector_match': 'Wrong business sector',
  'flag.reason.amount_fit': 'Unsuitable amount',
  'flag.reason.target_audience': 'Not my company type',
  'flag.reason.legal_entity': 'Incorrect legal form',
  'flag.reason.naf_code_match': 'Incompatible NAF code',
  'flag.reason.expired_deadline': 'Deadline expired',
  'flag.reason.wrong_amount': 'Displayed amount incorrect',
  'flag.reason.duplicate': 'Duplicate of another subsidy',
  'flag.reason.other': 'Other reason',

  // Error Boundary - Subsidy Detail
  'error.unableToLoadSubsidy': 'Unable to Load Subsidy Details',
  'error.loadingError': 'We encountered an error while loading the subsidy information. This might be due to a temporary issue or the subsidy may no longer be available.',
  'error.tryAgain': 'Try Again',
  'error.backToSearch': 'Back to Search',
  'error.contactSupport': 'Contact Support',
  'error.subsidyId': 'Subsidy ID',

  // Error Boundary - General
  'error.somethingWentWrong': 'Something went wrong',
  'error.formErrorDetected': 'Form Error Detected',
  'error.formComponentError': 'A form component error occurred while processing your request.',
  'error.typicallyHappensWhen': 'This typically happens when:',
  'error.documentImportFail': 'Document import fails to populate all required fields',
  'error.invalidDataDropdowns': 'Invalid data is loaded into form dropdowns',
  'error.networkInterrupt': 'Network issues interrupt the form loading process',
  'error.unexpectedError': 'An unexpected error occurred. We\'re sorry for the inconvenience.',
  'error.technicalDetails': 'Technical Details:',
  'error.copy': 'Copy',
  'error.goHome': 'Go Home',
  'error.formErrorPersists': 'If this error persists, try manually filling out the form fields or contact our support team for assistance.',
  'error.keepHappening': 'If this keeps happening, please contact our team so we can help you directly:',
  'error.copied': 'Copied',
  'error.errorDetailsCopied': 'Error details copied to clipboard',
} as const;
